<template>
    <div id="ficheDepartement">
        <viewpage :fullscreen="fullscreen">
            <template v-slot:menu>
                <menuSave 
                    :msg="sendMsg" 
                    newBtn 
                    :btnSaveDisabled="checkAllField" 
                    @new="menuNew()" 
                    saveBtn 
                    @save="menuSave()" 
                    :deleteBtn="checkDeleteBtn"
                    @delete="menuDelete(activeObj.id)"
                    :msgType="getTheme.primary">
                </menuSave>
            </template>

            <template v-slot:grid>
                <sItemList 
                    :isSelectOptions="isSelectOptions" 
                    :columns="columns" 
                    :rows="departmentList" 
                    :isResetBtn="true" 
                    activeField="isActive" 
                    :labelAdd="$t('Ajouter un produit')"
                    :searchTerm="searchText"
                    :fullscreen="fullscreen"
                    @on-row-click="onSelection" 
                    @on-expand-click="onExpandGrid"
                />
            </template>

            <template v-slot:form>
                <b-row style="padding:0 0; height:100%; border:0px solid red;overflow-y:auto">

                    <b-col :xs="12" :sm="12" :md="6" :lg="12" xl="6" style="border:0px dashed blue;height:auto">

                        <!--INFORMATIONS DU DEPARTEMENT-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('s_Informations')}}</div>
                                    <div class="itemContain">
                                        <s-input id = "description1" name="description1" type="text" maxlength="30" class="MargeTop15" :placeholder="$t('dpt_Description1')" v-capitalize v-model="activeObj.description1" :state="isValid(activeObj.description1)"></s-input>
                                        <s-input id = "description2" name="description2" type="text" maxlength="30" class="MargeTop15" :placeholder="$t('dpt_Description2')" v-capitalize v-model="activeObj.description2" ></s-input>
                                        
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <!--LIENS-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('dpt_Liens')}}</div>
                                    <div class="itemContain">
                                        <s-comboSelector 
                                            class="txtPrincipal" 
                                            showField="categoryName" 
                                            returnField="id" 
                                            :content="categoryList" 
                                            name= "categories" 
                                            :title="$t('dpt_Categories')" 
                                            :value="activeObj.categoryId" 
                                            :returnValue.sync="activeObj.categoryId" 
                                            :selectedItems="activeObj.categoryId" 
                                            :selectStatus="true">
                                        </s-comboSelector>
                                        <br/>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isFreeMenu">{{$t('dpt_LienMenuLibre')}}</b-form-checkbox>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <!--OPTIONS-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('dpt_Options')}}</div>
                                    <div class="itemContain">
                                        <b-row>
                                            <s-duoSelector :text1="$t('dpt_Vente')" :text2="$t('dpt_Encaisse')" :value="activeObj.isPaidIn" :returnValue.sync="activeObj.isPaidIn"></s-duoSelector>
                                            <s-duoSelector text1="+" text2="-" :value="activeObj.isNegative" :returnValue.sync="activeObj.isNegative"></s-duoSelector>
                                            <s-duoSelector :text1="$t('dpt_Fixe')" :text2="$t('dpt_Ouvert')" :value="activeObj.isOpen" :returnValue.sync="activeObj.isOpen"></s-duoSelector>
                                            <s-duoSelector :text1="$t('dpt_EscOn')" :text2="$t('dpt_EscOff')" :value="activeObj.isDiscount" :returnValue.sync="activeObj.isDiscount"></s-duoSelector>
                                        </b-row>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <!--TAXES-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('dpt_Taxes')}}</div>
                                    <div class="itemContain txtMain">
                                        <b-form-checkbox v-show="taxes.tx1.active" switch :size="chkSize" v-model="activeObj.isTax1">{{taxes.tx1.name}} <span class="txRate">({{taxes.tx1.rate}}%)</span></b-form-checkbox>
                                        <b-form-checkbox v-show="taxes.tx2.active" switch :size="chkSize" v-model="activeObj.isTax2">{{taxes.tx2.name}} <span class="txRate">({{taxes.tx2.rate}}%)</span></b-form-checkbox>
                                        <b-form-checkbox v-show="taxes.tx3.active" switch :size="chkSize" v-model="activeObj.isTax3">{{taxes.tx3.name}} <span class="txRate">({{taxes.tx3.rate}}%)</span></b-form-checkbox>
                                        <b-form-checkbox v-show="taxes.tx4.active" switch :size="chkSize" v-model="activeObj.isTax4">{{taxes.tx4.name}} <span class="txRate">({{taxes.tx4.rate}}%)</span></b-form-checkbox>
                                        <b-form-checkbox v-show="taxes.tx5.active" switch :size="chkSize" v-model="activeObj.isTax5">{{taxes.tx5.name}} <span class="txRate">({{taxes.tx5.rate}}%)</span></b-form-checkbox>
                                        <b-form-checkbox v-show="taxes.tx6.active" switch :size="chkSize" v-model="activeObj.isTax6">{{taxes.tx6.name}} <span class="txRate">({{taxes.tx6.rate}}%)</span></b-form-checkbox>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                    </b-col>
                    <b-col :xs="12" :sm="12" :md="6" :lg="12" xl="6" style="border:0px dashed blue;height:auto">
                        
                        <!--AUTRE-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('dpt_Autre')}}</div>
                                    <div class="itemContain txtMain">
                                        <b-row align-v="center">
                                            <b-col class="aRight" cols="5" xl="4">
                                                <span class="txtProfit">{{$t('dpt_ProfitMoyen')}}</span>
                                            </b-col>
                                            <b-col cols="6" xl="8">
                                                <b-row align-v="center">
                                                    <s-currencyInput class="convertQte" type="number" :step="0.5" append="%" id="txtProfit" name="txtProfit" v-model="activeObj.profitPercent"></s-currencyInput>
                                                </b-row>
                                            </b-col>
                                        </b-row>

                                        <s-duoSelector :text1="$t('dpt_Regulier')" :text2="$t('dpt_Essence')" :value="activeObj.isGazPrice" :returnValue.sync="activeObj.isGazPrice"></s-duoSelector>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isNotCalculateOnReport">{{$t('dpt_NonCalcul')}}</b-form-checkbox>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isForceOnReport">{{$t('dpt_ForceRapport')}}</b-form-checkbox>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isValidateAge">{{$t('dpt_ValiderAgeLegal')}}</b-form-checkbox>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isReportCadrin">{{$t('dpt_RapportCadrin')}}</b-form-checkbox>
                                        <b-form-checkbox switch :size="chkSize" v-model="activeObj.isPrintItemOnXZ">{{$t('dpt_ItemsXZ')}}</b-form-checkbox>

                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <!--COMPTE GL-->
                        <b-row>
                            <b-col xs="12" sm="12" md="12" lg="12" xl="6">
                                <div class="itemMain">
                                    <div class="itemSubTitle">{{$t('dpt_CompteGl')}}</div>
                                    <div class="itemContain">
                                        <s-input class="txtPrincipal" id="txtGl" name="txtGl" type="text" :placeholder="$t('dpt_GL') + ' : ' + $t('dpt_MagasinLocal')" v-model="activeObj.GL"></s-input>
                                        <s-input class="txtPrincipal" id="txtGl1" name="txtGl1" type="text" :placeholder="$t('dpt_GL') + ' : ' + $t('dpt_BureauChef')" v-model="activeObj.GL1"></s-input>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                    </b-col>
                </b-row>
            </template>

            <template v-slot:formTabs>
                <div class="row clearfix" style="border:0px solid blue;">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="card">
                            <div class="body">
                                <ul class="nav nav-tabs-new2">
                                    <li class="nav-item cursorPoint"><a class="nav-link" :class="{'active show': currentTab == 1}" @click="handleClick(1)"><span v-if="activeObj.id==0">Nouveau</span><span v-else>Edition</span></a></li>
                                    <li class="nav-item cursorPoint"><a class="nav-link" :class="{'active show': currentTab == 2}" @click="handleClick(2)">Home</a></li>
                                    <li class="nav-item cursorPoint"><a class="nav-link" :class="{'active show': currentTab == 3}" @click="handleClick(3)">Profile</a></li>
                                    <li class="nav-item cursorPoint"><a class="nav-link" :class="{'active show': currentTab == 4}" @click="handleClick(4)">Contact</a></li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane" :class="{'active show': currentTab == 1}">
                                        <b-row style="padding:0 0; height:100%; border:0px solid red;overflow-y:auto;border:0px dashed magenta;" :style="'height: ' + innerHeight + 'px;'">
                                            <b-col :xs="12" :sm="12" :md="6" :lg="12" xl="6" style="border:0px dashed blue;" >
                                                <!--INFORMATIONS DU DEPARTEMENT-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('s_Informations')}}</div>
                                                            <div class="itemContain">
                                                                <s-input id = "description1" name="description1" type="text" maxlength="30" class="MargeTop15" :placeholder="$t('dpt_Description1')" v-capitalize v-model="activeObj.description1" :state="isValid(activeObj.description1)"></s-input>
                                                                <s-input id = "description2" name="description2" type="text" maxlength="30" class="MargeTop15" :placeholder="$t('dpt_Description2')" v-capitalize v-model="activeObj.description2" ></s-input>
                                                                
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <!--LIENS-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('dpt_Liens')}}</div>
                                                            <div class="itemContain">
                                                                <s-comboSelector 
                                                                    class="txtPrincipal" 
                                                                    showField="categoryName" 
                                                                    returnField="id" 
                                                                    :content="categoryList" 
                                                                    name= "categories" 
                                                                    :title="$t('dpt_Categories')" 
                                                                    :value="activeObj.categoryId" 
                                                                    :returnValue.sync="activeObj.categoryId" 
                                                                    :selectedItems="activeObj.categoryId" 
                                                                    :selectStatus="true">
                                                                </s-comboSelector>
                                                                <br/>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isFreeMenu">{{$t('dpt_LienMenuLibre')}}</b-form-checkbox>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <!--OPTIONS-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('dpt_Options')}}</div>
                                                            <div class="itemContain">
                                                                <b-row>
                                                                    <s-duoSelector :text1="$t('dpt_Vente')" :text2="$t('dpt_Encaisse')" :value="activeObj.isPaidIn" :returnValue.sync="activeObj.isPaidIn"></s-duoSelector>
                                                                    <s-duoSelector text1="+" text2="-" :value="activeObj.isNegative" :returnValue.sync="activeObj.isNegative"></s-duoSelector>
                                                                    <s-duoSelector :text1="$t('dpt_Fixe')" :text2="$t('dpt_Ouvert')" :value="activeObj.isOpen" :returnValue.sync="activeObj.isOpen"></s-duoSelector>
                                                                    <s-duoSelector :text1="$t('dpt_EscOn')" :text2="$t('dpt_EscOff')" :value="activeObj.isDiscount" :returnValue.sync="activeObj.isDiscount"></s-duoSelector>
                                                                </b-row>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <!--TAXES-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('dpt_Taxes')}}</div>
                                                            <div class="itemContain txtMain">
                                                                <b-form-checkbox v-show="taxes.tx1.active" switch :size="chkSize" v-model="activeObj.isTax1">{{taxes.tx1.name}} <span class="txRate">({{taxes.tx1.rate}}%)</span></b-form-checkbox>
                                                                <b-form-checkbox v-show="taxes.tx2.active" switch :size="chkSize" v-model="activeObj.isTax2">{{taxes.tx2.name}} <span class="txRate">({{taxes.tx2.rate}}%)</span></b-form-checkbox>
                                                                <b-form-checkbox v-show="taxes.tx3.active" switch :size="chkSize" v-model="activeObj.isTax3">{{taxes.tx3.name}} <span class="txRate">({{taxes.tx3.rate}}%)</span></b-form-checkbox>
                                                                <b-form-checkbox v-show="taxes.tx4.active" switch :size="chkSize" v-model="activeObj.isTax4">{{taxes.tx4.name}} <span class="txRate">({{taxes.tx4.rate}}%)</span></b-form-checkbox>
                                                                <b-form-checkbox v-show="taxes.tx5.active" switch :size="chkSize" v-model="activeObj.isTax5">{{taxes.tx5.name}} <span class="txRate">({{taxes.tx5.rate}}%)</span></b-form-checkbox>
                                                                <b-form-checkbox v-show="taxes.tx6.active" switch :size="chkSize" v-model="activeObj.isTax6">{{taxes.tx6.name}} <span class="txRate">({{taxes.tx6.rate}}%)</span></b-form-checkbox>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                            </b-col>
                                            <b-col :xs="12" :sm="12" :md="6" :lg="12" xl="6" style="border:0px dashed blue;height:auto">
                                                
                                                <!--AUTRE-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('dpt_Autre')}}</div>
                                                            <div class="itemContain txtMain">
                                                                <b-row align-v="center">
                                                                    <b-col class="aRight" cols="5" xl="4">
                                                                        <span class="txtProfit">{{$t('dpt_ProfitMoyen')}}</span>
                                                                    </b-col>
                                                                    <b-col cols="6" xl="8">
                                                                        <b-row align-v="center">
                                                                            <s-currencyInput class="convertQte" type="number" :step="0.5" append="%" id="txtProfit" name="txtProfit" v-model="activeObj.profitPercent"></s-currencyInput>
                                                                        </b-row>
                                                                    </b-col>
                                                                </b-row>

                                                                <s-duoSelector :text1="$t('dpt_Regulier')" :text2="$t('dpt_Essence')" :value="activeObj.isGazPrice" :returnValue.sync="activeObj.isGazPrice"></s-duoSelector>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isNotCalculateOnReport">{{$t('dpt_NonCalcul')}}</b-form-checkbox>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isForceOnReport">{{$t('dpt_ForceRapport')}}</b-form-checkbox>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isValidateAge">{{$t('dpt_ValiderAgeLegal')}}</b-form-checkbox>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isReportCadrin">{{$t('dpt_RapportCadrin')}}</b-form-checkbox>
                                                                <b-form-checkbox switch :size="chkSize" v-model="activeObj.isPrintItemOnXZ">{{$t('dpt_ItemsXZ')}}</b-form-checkbox>

                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <!--COMPTE GL-->
                                                <b-row>
                                                    <b-col xs="12" sm="12" md="12" lg="12" xl="6">
                                                        <div class="itemMain">
                                                            <div class="itemSubTitle">{{$t('dpt_CompteGl')}}</div>
                                                            <div class="itemContain">
                                                                <s-input class="txtPrincipal" id="txtGl" name="txtGl" type="text" :placeholder="$t('dpt_GL') + ' : ' + $t('dpt_MagasinLocal')" v-model="activeObj.GL"></s-input>
                                                                <s-input class="txtPrincipal" id="txtGl1" name="txtGl1" type="text" :placeholder="$t('dpt_GL') + ' : ' + $t('dpt_BureauChef')" v-model="activeObj.GL1"></s-input>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div class="tab-pane" :class="{'active show': currentTab == 2}">
                                        <h6>Home</h6>
                                        <p>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
                                    </div>
                                    <div class="tab-pane" :class="{'active show': currentTab == 3}">
                                        <h6>Profile</h6>
                                        <p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR banksy irony. Leggings gentrify squid 8-bit cred pitchfork. Williamsburg banh mi whatever gluten-free, carles pitchfork biodiesel </p>
                                    </div>
                                    <div class="tab-pane" :class="{'active show': currentTab == 4}">
                                        <h6>Contact</h6>
                                        <p>Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            



        </viewpage>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'
import mapGetter from '@/mixins/getters.js'
import menuSave from '@/components/general/s-menuSave/s-menuSave3.vue'
import departmentColumnHeaders from '@/mixins/departmentColumnHeaders.js';
import {dataService} from '@/services'
import SocketioService from '@/plugins/socket/socketio.service.js'
import store from '@/store'

import sItemList from '@/components/communs/s-itemList/s-itemList3.vue'

import viewpage from '@/components/communs/s-layout/s-viewpage.vue'

export default{
    name: "ficheDepartement",
    mixins:[mapGetter, departmentColumnHeaders],
    components: {
        menuSave,
        sItemList,
        viewpage,
    },
    data() {
        return{
            InitialState: null, //Format initial de : activeObj
            activeObj:{}, //Créé à l'ouverture à partir du modèle vide dans l'api
            originalObj : {},
            leftSize: 12,

            isSelectOptions : false,
            columns : [],
            rows: [],
            searchText: '',
            fullscreen: false,


            currentTab: 1,

            
            fields:[
                {
                    colName: "id",
                    label: "id",
                    show: false,
                },
                {
                    colName: "description1",
                    label: this.$i18n.t('dpt_Description1') ,
                    show: true,
                },
                {
                    colName: "description2",
                    label: this.$i18n.t('dpt_Description2') ,
                    show: true,
                },
            ], 
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '4', //message a utiliser pour le menu en haut de la page New/Save/Delete

            taxes: {
                tx1: {
                    active: true,
                    name: 'Tps',
                    rate: 5,
                    include: false
                },
                tx2: {
                    active: true,
                    name: 'Tvq',
                    rate: 9.975,
                    include: false
                },
                tx3: {
                    active: true,
                    name: 'Tps inc.',
                    rate: 5,
                    include: true
                },
                tx4: {
                    active: true,
                    name: 'Tvq inc.',
                    rate: 9.975,
                    include: true
                },
                tx5: {
                    active: false,
                    name: '',
                    rate: 0,
                    include: false
                },
                tx6: {
                    active: false,
                    name: '',
                    rate: 0,
                    include: false
                }
            }
        
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        handleClick(newTab) {
            this.currentTab = newTab;
        },
        onExpandGrid(params) 
        {
            this.fullscreen = params.fullscreen
        },
        showFields() 
        {
            this.fullscreen = false
            this.currentTab = 1
        },
        hideFields() 
        {
            this.fullscreen = true
        },
        loadColumns()
        {
            this.columns = this.$CObj(this.getItemColumnHeaders());
        },
        /**
         * Reinitialise tous les champs de la fiche département
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
            this.currentTab = 1
        },
        /**
         * Crée un nouveau fiche département vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des départements 
         */
        loadApi() {      
            this.sendMsg = '-'      
            if(typeof this.payload?.data?.departmentList == 'undefined') {
                //Charger les départements depuis le serveur si ils ne sont pas présent locallement
                dataService.getDepartments()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg = ''
                        let data = response.data;
                        return data;
                    }
                })
                .then(response => {
                    console.log(response)
                    this.departmentList = this.$CObj(response.data.departmentList)
                    this.InitialState = this.$CObj(response.addons.classes.departmentList[0])
                    this.activeObj = this.$CObj(this.InitialState)
                    this.originalObj = this.$CObj(this.InitialState)
                })
                .catch(error =>{
                    this.sendMsg = ''
                    console.log(error);
                })

            } else {
                //Les données chargées depuis le localStorage
                this.InitialState = this.$CObj(this.payload.addons.classes.departmentList[0])
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.InitialState)
                this.sendMsg = ''
            }
        },
        /**
         * Sauvegarde la fiche département
         */
        menuSave(){
            this.sendMsg = '-' 
            setTimeout(() => { 
                let t = this.activeObj
                if (t.id == 0) //CRÉATION D'UN NOUVEAU
                {
                    this.sendMsg = '-'
                    dataService.addDepartment(t)
                    .then((response) => {
                        console.log(response)
                        if(response.statusText == 'OK')
                        {
                            //this.sendMsg = ''
                            const newDepartment = response.data.data
                            SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'departments', payload: newDepartment});
                            this.departmentList.unshift(newDepartment)
                            this.resetAll()
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                }
                else //MODIFICATION D'UN EXISTANT
                {
                    this.sendMsg = '-'
                    dataService.updateDepartment(t)
                    .then((response) => {
                        if(response.statusText == 'OK')
                        {
                            if(response.data)
                            {
                                const updatedDepartment = response.data.data
                                SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'departments', payload: updatedDepartment});
                                this.departmentList = this.departmentList.map(dept => {
                                    if(dept.id == updatedDepartment.id)  Object.assign(dept, updatedDepartment) ;
                                    return dept;
                                });
                                this.resetAll()
                            }
                        }
                        this.sendMsg = ''
                    })
                    .catch((error) => {
                        //this.sendMsg = ''
                        console.log(error);
                        alert('update KO');
                    });
                }
                if(this.fullscreen) this.hideFields();
                this.sendMsg = '' 
            }, 100)
        },
        /**
         * Désactive la fiche catégorie
         * @param {int} id - id de la catégorie
         */
        menuDelete(id){
            if (id == '0') return;
            this.sendMsg = '-'
            dataService.deleteDepartment(id)
            .then((response) => {
                if(response.statusText == 'OK')
                {   
                    this.sendMsg = ''
                    SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'departments', payload: {id:id, isActive:false}});
                    this.departmentList = this.departmentList.map(dept => {
                        if(dept.id == id)  dept.isActive = !dept.isActive;
                        return dept;
                    });
                    this.resetAll()
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = '';
                console.log(error);
            });
        },
        /**
         * Retourne les détails de la catégorie 
         * @param {int} id - id de la catégorie
         */
        onSelection(id){
            this.showFields()
            this.sendMsg = '-'

            setTimeout(() =>{
                //Aller chercher les information du département
                dataService.getDepartment(id)
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        let addons = response.data.addons
                        let departmentList = response.data.data
                        let dept = departmentList.find(cat => typeof cat !== 'undefined' && cat.id == id);

                        if(dept)
                        {
                            this.activeObj = this.$CObj(dept)
                            this.originalObj = this.$CObj(this.activeObj)
                            this.InitialState = this.$CObj(addons.classes)
                        }
                    }
                    this.sendMsg = ''
                })
                .catch(error =>{
                    this.sendMsg = ''
                    console.log(error);
                })
            }, 300);            
        },

        
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getScreenSize', 'getCheckSize', 'getAllSize']),
        /**
         * Vérifie s'il ya des modifications
         */
        checkAllField() {
            return JSON.stringify(this.originalObj) == JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du client
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
         payload : () => store.getters.getInventory,
        /**
         * Retourne la liste des départements du payload
         */
         departmentList() {return this.payload?.data.departmentList},
        /**
         * Retourne la liste des categories du payload
         */
         categoryList() {return this.payload?.data.categoryList},

         innerHeight(){
            return this.getScreenSize.height 

        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() 
        this.loadColumns()
    },
    updated() {
        this.resetAll()
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
            }
        },
    }
}
</script>

<style lang="scss" scoped>

    .card {
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        background: #fff;
        border-color: #eee;
        margin-bottom: 0px;
        position: relative;
        width: 100%;
        height:100%;
        border-color: #e7e0e0;
    }

    .card:hover {
        box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1)
    }

    .card .header {
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #444;
        padding: 20px;
        position: relative
    }

    .card .header.bline {
        border-bottom: 1px solid #eee
    }

    .card .header .header-dropdown {
        position: absolute;
        top: 14px;
        right: 20px;
        list-style: none
    }

    .card .header .header-dropdown li a {
        padding: 5px 10px;
        color: #999
    }

    .card .header .header-dropdown li a.dropdown-toggle:after {
        border: none;
        content: '\f141';
        font-family: 'FontAwesome';
        vertical-align: text-top;
        width: 11px
    }

    .card .header .header-dropdown li .dropdown-menu {
        border-radius: .55rem;
        overflow: hidden;
        right: 0;
        padding: 10px;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.2);
        border: 0
    }

    .card .header .header-dropdown li .dropdown-menu li {
        display: block !important
    }

    .card .header .header-dropdown li .dropdown-menu li a {
        color: #777;
        padding: 10px;
        white-space: nowrap
    }

    .card .header .header-dropdown li .dropdown-menu li a:hover {
        color: #444
    }

    .card .header h2 {
        font-weight: 600;
        color: #444;
        position: relative
    }

    .card .header h2 small {
        color: #999;
        line-height: 15px
    }

    .card .header h2 small a {
        font-weight: 700;
        color: #777
    }

    .card .p-15 {
        padding: 15px !important
    }

    .card .body {
        font-weight: 400;
        color: #444;
        padding: 20px 20px 20px 20px;
        //height:100%;

        border:0px solid red;
    }

    .nav.nav-tabs-new2 {
        border-bottom: 1px solid #eee;
    }

    .nav.nav-tabs-new2>li>a {
        color: #777;
        padding: 7px 20px;
        background-color: transparent;
        border-bottom: transparent;
        font-size: 15px;
    }

    .nav.nav-tabs-new2>li>a:hover,
    .nav.nav-tabs-new2>li>a:focus {
        color: #00bcd2;
        border-bottom: 2px solid #00bcd2 !important
    }

    .nav.nav-tabs-new2>li>a.active {
        border-bottom: 2px solid #00bcd2 !important;
        background-color: transparent;
        color: #00bcd2
    }

    .tab-content{
        margin-top: 10px
    }



</style>